<div class="col-sm-12" *ngIf="!isEditLocation" style="height: 100%; padding: 5px 0;">
  <div class="fiche col-sm-12" style="padding: 2px 20px 5px 20px;">
      <div class="text-right col-sm-12 pull-right" style="padding: 0;">
          <div class="col-sm-4 fiche-client" style="margin-top: 5px">
              <div> Histo des prestations </div>
          </div>

          <button class="uppercase btn-close" id="savecont" (click)="recreatePresta()"> Recréer la prestation sélectionnée </button>
          <button class="uppercase" id="closeclt" (click)="fermer()"> Annuler </button>
      </div>
  </div>
  <div class="contente listeHistoBenne listeprestation col-sm-12" id="ContPlusPrest" style="color: #000; padding: 15px 15px 0; font-size: 13px;">
      <div class="col-sm-12" style="padding: 15px 0px 0px 0px" [ngStyle]="{'height': '100%'}">
        <ngx-datatable style="height: 100%;" #myTable class="material " [ngClass]="{'histoFact': (nbPage ) > 1 }"
          [rows]="rows" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="((nbPage ) > 1 ? 40 : 0)"
          [rowHeight]="getRowHeight" [selected]="selected" [selectionType]="'single'" (select)="onSelect($event)"
          [messages]="{emptyMessage:  loadingIndicator ? 'Chargement ...' : 'Pas de bon à afficher'}"
          [loadingIndicator]="loadingIndicator"  >
          <!-- <ngx-datatable-column prop="chantier.responsable" >
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
              let-sort="sortFn">
              <div class="tableheader" (click)="sortBy('chantiers.Responsable')">
                <span class="uppercase"> Responsable </span>
                <div class=" shorticone pull-right">
                  <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                  <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                </div>
              </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <div class="strong disable-select" >
                <span> {{value}} </span>
              </div>
            </ng-template>
          </ngx-datatable-column> -->
          <ngx-datatable-column name="Date" prop="chantier.numChantier" >
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
              let-sort="sortFn">
              <div class="tableheader" (click)="sortBy('DescriptionChantier')">
                <span class="uppercase">Chantier</span>
                <div class=" shorticone pull-right">
                  <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                  <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                </div>
              </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <div class="strong disable-select">{{ row.chantier ? row.chantier.numChantier || '' : '' }}</div>
              <div class="strong disable-select">{{ row.chantier ? row.chantier.responsable || '' : '' }}</div>
              <div class="strong disable-select">{{ row.chantier ? row.chantier.ville || '' : '' }}</div>
            </ng-template>
          </ngx-datatable-column>
          <!-- <ngx-datatable-column name="Echeance" prop="chantier.ville">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
              let-sort="sortFn">
              <div class="tableheader" (click)="sortBy('chantiers.Ville')">
                <span class="uppercase"> Ville </span>
                <div class=" shorticone pull-right">
                  <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                  <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                </div>
              </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <div class="strong disable-select">{{value}}</div>
            </ng-template>
          </ngx-datatable-column> -->
          <ngx-datatable-column name="NumFact" prop="article.libelle" >
            <ng-template let-col="column" ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
              let-selectFn="selectFn" let-sort="sortFn">
              <div class="tableheader" (click)="sortBy('article.libelle')">
                <span class="uppercase">Prestation</span>
                <div class=" shorticone pull-right">
                  <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                  <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                </div>
              </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <div class="strong disable-select"> {{value}} </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Client" prop="dateDebut">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
              let-sort="sortFn">
              <div class="tableheader" (click)="sortBy('locationMateriel.dateDebut')">
                <span class="uppercase">Date début</span>
                <div class=" shorticone pull-right">
                  <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                  <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                </div>
              </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <div class="strong disable-select" > {{value}} </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Client" prop="dateFin">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
              let-sort="sortFn">
              <div class="tableheader" (click)="sortBy('locationMateriel.dateFin')">
                <span class="uppercase">Date fin</span>
                <div class=" shorticone pull-right">
                  <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                  <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                </div>
              </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <div class="strong disable-select" > {{value}} </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Infos" prop="infosFact">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
              let-sort="sortFn">
              <div class="tableheader" (click)="sortBy('locationMateriel.infosFact')">
                <span class="uppercase">Infos</span>
                <div class=" shorticone pull-right">
                  <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                  <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                </div>
              </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <div class="strong ellipsis disable-select" > {{ value }} </div>
              <!-- {{ getTextInfos(row) }} -->
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Infos" prop="exutoire.nom">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
              let-sort="sortFn">
              <div class="tableheader" (click)="sortBy('Exutoire.nom')">
                <span class="uppercase">Exutoire</span>
                <div class=" shorticone pull-right">
                  <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                  <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                </div>
              </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <div class="strong ellipsis disable-select" > {{ value }} </div>
              <!-- {{ getTextInfos(row) }} -->
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Infos" prop="chauffeur">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
              let-sort="sortFn">
              <div class="tableheader" (click)="sortBy('Personnel')">
                <span class="uppercase">Personnel</span>
                <div class=" shorticone pull-right">
                  <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                  <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                </div>
              </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <div class="strong ellipsis disable-select" *ngIf="value" > {{ value.nom || '' }} {{ value.prenom || '' }} </div>
            </ng-template>
          </ngx-datatable-column>
          
          
          <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template let-pageSize="pageSize" let-selectedCount="selectedCount"
              let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
        
              <datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'"
                [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="page+1" [size]="50"
                [count]="rowCount" [hidden]="!((rowCount / 50) > 1)" (change)="onFooterPage($event)">
              </datatable-pager>
            </ng-template>
          </ngx-datatable-footer>
        </ngx-datatable>
      </div>
  </div>
</div>



<ng-template #msg>
  <div class="modal-body" style="height: auto">
      <div>
          <div class="col-sm-12">
              <strong class="cofirmemsg"> {{ error }} </strong>
          </div>
      </div>
      <div class="text-right" style="margin-top: 15px;">
          <button type="button" class=" btn-close btn-valider" (click)="common.closeModal()"> Fermer </button>
      </div>
  </div>
</ng-template>
